import { AdState } from './ad-state';
import { isGetUserFinished } from '../general/modules/getUser';

export class AdStateAuthFactory {
    public async getState(): Promise<AdState> {
        await isGetUserFinished();
        return new AdState(window.app.getGameStartDataResponse.human_data.refState);
    }
}
